import ProxyServerConnector from './ProxyServerConnector';

declare let GATEWAY_PREFIX: string;

export type HttpClient = Pick<
    ProxyServerConnector,
    'get' | 'post' | 'put' | 'delete' | 'download' | 'send' | 'abortRequest'
>;

export function gatewayClient(basePath: string): HttpClient {
    return new ProxyServerConnector(basePath, GATEWAY_PREFIX);
}

export function createService<T extends Record<string, unknown>>(
    client: HttpClient,
    methodsFactory: (client: HttpClient) => T,
): HttpClient & T {
    // Bind the client methods to ensure 'this' context is preserved for the base methods
    const bindMethod = <M extends (...args: unknown[]) => unknown>(method: M) => method.bind(client);

    const baseMethods = {
        get: bindMethod(client.get),
        post: bindMethod(client.post),
        put: bindMethod(client.put),
        delete: bindMethod(client.delete),
        download: bindMethod(client.download),
        send: bindMethod(client.send),
        abortRequest: bindMethod(client.abortRequest),
    };

    return {
        ...baseMethods,
        ...methodsFactory(client),
    } as HttpClient & T;
}
